export default __webpack_public_path__ + "static/media/startup.a0405f24.svg";